import { useParams } from 'react-router-dom';
import { getTranslate } from '../../utils/getTranslate/getTranslate';
import { getLocalPath } from '../../utils/getLocatPath/getLocalPath';
import { PageMetaData } from '../../components/providers/pageMetaData/pageMetaData';
import { ErrorState } from '../../components/blocks/errorState/ErrorState';
import { Content } from './components/Content';
import styles from './FormPost.module.scss';

export const FormPost = ({ applications }) => {
  const t = getTranslate;
  const { lang } = useParams();
  const params = useParams();
  const upApplication = !!applications ? applications.find((el) => el.acf.slug == params.slug) : false;

  if (!applications) {
    return (
      <>
        <main className="main padding-header"></main>
      </>
    );
  }

  if (!upApplication) {
    const title = t('Ой! Қолданба табылмады.', 'Упс! Заявка не найдена.', lang);
    const message = t(
      'Бұл бет жойылған немесе ешқашан болмаған сияқты.',
      'Похоже, эта страница была удалена или никогда не существовала.',
      lang,
    );
    const linkText = t('Үйге оралу', 'Назад к главную', lang);
    const linkUrl = getLocalPath('', lang);
    const seo = {
      title: {
        kz: 'Ой! Қолданба табылмады.',
        ru: 'Упс! Заявка не найдена.',
      },
      description: {
        kz: 'Бұл бет жойылған немесе ешқашан болмаған сияқты.',
        ru: 'Похоже, эта страница была удалена или никогда не существовала.',
      },
    };
    return (
      <>
        <PageMetaData seo={seo} />
        <main className="main padding-header">
          <ErrorState title={title} message={message} linkText={linkText} linkUrl={linkUrl} />
        </main>
      </>
    );
  }

  const { title } = !!upApplication ? upApplication.acf.info : false;
  const seo = !!upApplication ? upApplication.acf.seo : false;

  return (
    <>
      {<PageMetaData seo={seo} />}
      <main className="main padding-header">{!!upApplication ? <Content upApplication={upApplication} /> : ''}</main>
    </>
  );
};
